import { rem } from 'polished';
import styled, { keyframes } from 'styled-components';

import { bokehTheme as theme } from '@vimeo/bokeh-theme';
import { Button } from '@vimeo/iris/components';

export const Form = styled.form`
  display: flex;
  flex-direction: column;
`;

const fadeIn = keyframes`
  0% { opacity: 0 }
  100% { opacity: 1 }
`;

export const FormError = styled.div`
  width: 100%;
  margin: 0 auto 0.5rem;
  padding: ${rem(12)} ${rem(48)} ${rem(12)} ${rem(16)};
  background: ${theme.colors.red['50']};
  border-radius: ${rem(3)};
  animation: ${fadeIn} 300ms ease-in-out both 150ms;
`;

export const Checkboxes = styled.div`
  margin-top: 0.5rem;
  padding-left: ${rem(32)};

  label {
    margin-bottom: 0.5rem !important;
  }
`;

export const SubmitButton = styled(Button)<{ type: string }>`
  align-self: flex-end;
`;
